module.exports = __webpack_public_path__ + "img/Origine_France_Officiel2.0c4a7fd1.png";